import { createStore as createZustandStore, type StateCreator, type StoreApi } from 'zustand/vanilla';

export function createStore<TState>(initializer: StateCreator<TState, [], [], TState>): StoreApi<TState> {
  return createZustandStore<TState>()(initializer);
}
